import { objectToQueryString } from '../objectToQueryString';

const numberOfItems = 10;
export default class GoogleSearch {
	constructor(config) {
		this.config = config;
		this.start = 1;
	}

	reset() {
		this.start = 0;
	}

	getOptions() {
		return {};
	}

	getRequest(options) {
		const params = {
			cx: this.config.cx,
			key: this.config.key,
			q: options.query,
			sort: options.sortType || this.config.sort,
			num: this.config.num || numberOfItems,
			start: options.start || this.start,
			lr: options.lr || ''
		};
		const url = `${this.config.url}?${objectToQueryString(params)}`;
		return { params, url };
	}

	parseResponse(data) {
		return data;
	}
}
